import { Label } from "../model/Label.js";
import { BaseElement, BaseElementOptions } from "./BaseElement.js";

export interface OfflineOptions extends BaseElementOptions {

}

export class Offline extends BaseElement {

    private _isOnline: boolean = true;
    private _enabled: boolean = true;

    public create(options: OfflineOptions): this {

        var e = document.createElement("div");
        e.className = "awi-offline e5-hidden";
        e.innerHTML = `
        <div class="awi-offline__content">
            <div class="awi-offline__icon">
                <span class="fal fa-wifi-slash"></span>
            </div>
            <div class="awi-offline__info">
                <div class="awi-offline__title"></div>
                <div class="awi-offline__text"></div>
                <div class="awi-offline__button">
                    <button class="awi-offline__button-continue">
                        <span class="awi-offline__button-label"></span>
                        <span class="awi-offline__button-icon fal fa-repeat-alt"></span>
                    </button>
                </div>
            </div>
        </div>
        `;

        super.create(options);
        super.setElement(e);

        Label.set(e.querySelector(".awi-offline__title"), "main.offline.title");
        
        //Hidden by CSS
        Label.set(e.querySelector(".awi-offline__text"), "main.offline-live.text");

        //Hidden by CSS
        Label.set(e.querySelector(".awi-offline__button-label"), "main.offline.ignore");

        window.addEventListener("online", () => this.setIsOnline(true));
        window.addEventListener("offline", () => this.setIsOnline(false));
        this.setIsOnline(navigator.onLine !== undefined ? navigator.onLine : true);

        e.querySelector(".awi-offline__button-continue").addEventListener("click", () => {
            this.visible = false
        });

        return this;
    }

    public get isOnline(): boolean {
        return this._isOnline;
    }

    private setIsOnline(value: boolean) {
        this._isOnline = value;
        document.documentElement.setAttribute("data-online", value ? "true" : "false");
        this.updateVisibility();
    }

    public get enabled(): boolean {
        return this._enabled;
    }

    public set enabled(value: boolean) {
        this._enabled = value;
        this.updateVisibility();
    }

    private updateVisibility(): void {
        if (this.enabled) {
            this.visible = !this.isOnline;
        } else {
            this.visible = false;
        }
    }
}